/** Session-scoped chat UI hints — revalidated on each visit via API. */

const HAS_EXTRACTIONS_KEY = "albis.chatHasExtractions";

/** @returns {boolean | null} */
export function getCachedHasExtractions() {
  try {
    const value = sessionStorage.getItem(HAS_EXTRACTIONS_KEY);
    if (value === "1") return true;
    if (value === "0") return false;
    return null;
  } catch {
    return null;
  }
}

/** @param {boolean} hasExtractions */
export function setCachedHasExtractions(hasExtractions) {
  try {
    sessionStorage.setItem(HAS_EXTRACTIONS_KEY, hasExtractions ? "1" : "0");
  } catch {
    /* ignore */
  }
}

export function clearCachedHasExtractions() {
  try {
    sessionStorage.removeItem(HAS_EXTRACTIONS_KEY);
  } catch {
    /* ignore */
  }
}

const WEEK_AGENDA_KEY = "albis.chatWeekAgenda";

/** Raw saved rows for this week's card. Session only; a closed tab drops them. */
export function readWeekAgenda() {
  try {
    const raw = sessionStorage.getItem(WEEK_AGENDA_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed?.items) ? parsed.items : [];
  } catch {
    return [];
  }
}

/** @param {object[]} items */
export function writeWeekAgenda(items) {
  try {
    sessionStorage.setItem(WEEK_AGENDA_KEY, JSON.stringify({ items: items || [] }));
  } catch {
    /* ignore */
  }
}

export function clearWeekAgenda() {
  try {
    sessionStorage.removeItem(WEEK_AGENDA_KEY);
  } catch {
    /* ignore */
  }
}
